// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Messages":"cp_a bhf_a bhf_w","Messages__hasSeen":"cp_b bhf_p"};